import { render } from "./IconVerified.vue?vue&type=template&id=ad4838ec"
import script from "./IconVerified.vue?vue&type=script&lang=js"
export * from "./IconVerified.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__